export default "__VITE_ASSET__B0lG$j7O__"